import { getDateTime } from 'services/types';
import { ZonesIcons } from 'libs/ui';
import { getAmount } from 'libs/common';

export const getTableParams = (t) => {
  const getFields = () => {
    const fields = [
      { name: 'created_at', sortField: 'created_at', title: t('grid.Дата и время'), width: 220, render: (val) => getDateTime(val) },
      {
        name: 'vehicle_plate',
        title: t('sections.ГРЗ'),
      },
      {
        name: 'mean_id',
        title: t('grid.СО'),
        width: 200,
      },
      {
        name: 'amount',
        title: t('grid.Сумма'),
        width: 100,
        sortField: 'amount',
        render: (val) => getAmount(val),
        numeric: true,
        clip: true,
      },
      {
        name: 'zones',
        title: t('grid.Зона'),
        width: 'auto',
        render: (val) => <ZonesIcons stayZones={val} />,
      },
      {
        name: 'comment',
        title: t('form.Причина'),
        // width: 200,
      },
    ];

    if (window.config.central) {
      fields.unshift({
        name: 'parking_id',
        title: t('grid.Парковка'),
        render: (val) => <ParkingCell parking_id={val} cmp={'span'} />,
        width: 'auto',
      });
    }

    return fields;
  };

  return { getFields };
};
